const cubeData = {
  sides: {
    front: {
      label: "front",
      textures: {
        desktop:
          "https://www.datocms-assets.com/40484/1732911921-nim-blue-bg.png",
        mobile:
          "https://www.datocms-assets.com/40484/1732909888-nim-palm-toy-bg-mobile.png",
      },
      position: { x: 0, y: -Math.PI * 0.5 },
    },
    back: {
      label: "back",
      textures: {
        desktop:
          "https://www.datocms-assets.com/40484/1732909884-nim-palm-bg.png",
        mobile:
          "https://www.datocms-assets.com/40484/1733053386-nim-dolphin-bg-mobile-flipped.png",
      },
      position: { x: 0, y: Math.PI * 0.5 },
    },
    top: {
      label: "top",
      position: { x: Math.PI * 0.5, y: 0 },
      video: {
        desktop:
          "https://www.datocms-assets.com/40484/1732883818-pool-video.mov",
      },
    },
    bottom: {
      label: "bottom",
      textures: {
        desktop:
          "https://www.datocms-assets.com/40484/1732909884-nim-palms-water-bg.png",
        mobile:
          "https://www.datocms-assets.com/40484/1732911921-nim-blue-bg.png",
      },
      position: { x: Math.PI / 2, y: 0 },
    },
    left: {
      label: "left",
      textures: {
        desktop:
          "https://www.datocms-assets.com/40484/1732909884-nim-palm-toy-bg.png",
        mobile:
          "https://www.datocms-assets.com/40484/1733054656-nim-palms-water-bg-mobile-flipped.png",
      },
      position: { x: 0, y: 0 },
    },
    right: {
      label: "right",
      textures: {
        desktop:
          "https://www.datocms-assets.com/40484/1732909884-nim-palms-bg.png",
      },
      video: {
        mobile:
          "https://www.datocms-assets.com/40484/1733057203-artdecofacade_1.mp4",
      },
      position: { x: 0, y: Math.PI },
    },
  },
};

export { cubeData };
